/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { changeActiveEntryLogging } from "apis/visitors";
import Root from "pages/root";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { userInfo } from "recoil/recoilState";
import { theme } from "styles/theme";
import IOSSwitch from "uis/iosSwitch";
import AlertModal from "uis/modal/alert-modal";
import { Heading, Container } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { getWorkspacesEntryLogging } from "apis/workspace/visitors";

const Label = styled.p`
  color: ${theme.neutral900};
  font-size: 16px;
  font-weight: 600;
`;

const Annotation = styled.p`
  color: ${theme.neutral600};
  font-size: 14px;
  font-weight: 400;
`;

const SettingContainer = styled.div`
  display: flex;
  background-color: ${theme.neutral50};
  justify-content: space-between;
  align-items: center;
  padding: 22px 30px;
`;

export default function PolicyManage() {
  const { workspace } = useRecoilValue(userInfo);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    getWorkspacesEntryLogging().then((res) => {
      if (res.success && res.data) {
        setIsActive(res.data);
      }
    });
    if (workspace) setIsActive(workspace.isEntryLoggingEnabled);
  }, [workspace]);

  return (
    <Container>
      <Heading>
        <UI.Typography
          type="title03"
          fontStyle="bold"
          color="var(--alias-color-label-neutral)"
          style={{
            padding: "24px 0 24px 20px",
          }}
        >
          체크인/체크아웃 정책 관리
        </UI.Typography>
      </Heading>
      <div
        css={css`
          display: flex;
          flex-direction: column;
        `}
      >
        <SettingContainer>
          <div
            css={css`
              display: flex;
              flex-direction: column;
              gap: 12px;
            `}
          >
            <Label>방문자 체크인/체크아웃 기록 활성화</Label>
            <Annotation>
              활성화 시, 태블릿을 활용하여 방문자의 체크인/체크아웃 기록을 남길 수 있습니다. <br />
              <span
                css={css`
                  color: #ff3e3e;
                `}
              >
                <ul>체크인/체크아웃 기록을 남기기 위해 모든 Visitors 태블릿의 방문 확인 과정이 변경됩니다.</ul>
              </span>
            </Annotation>
          </div>
          <IOSSwitch checked={isActive} onChange={() => setOpen(true)} />
        </SettingContainer>
        <AlertModal
          modalIsOpen={open}
          title={
            isActive ? "체크인/체크아웃 기록을 비활성화 하시겠습니까?" : "체크인/체크아웃 기록을 활성화 하시겠습니까?"
          }
          onChange={async () => {
            const res = await changeActiveEntryLogging(!isActive);

            if (res.success) {
              setIsActive(!isActive);
              setOpen(false);
            }
          }}
          btnTitle="변경하기"
          content={
            <p
              css={css`
                text-align: center;
              `}
            >
              체크인/체크아웃 기록을 남기기 위해 모든
              <br />
              Visitors 태블릿에서 방문 확인 과정이 변경됩니다.
            </p>
          }
          closeModal={() => {
            setOpen(false);
          }}
        />
      </div>
    </Container>
  );
}
